export const isProduction = () => {
	// TODO: window.location.hostname === process.env.PRODUCTION_HOSTNAME;
	return process.env.NEXT_PUBLIC_IS_PRODUCTION === 'true';
};
